import { CompanyPayload, DriverPayload } from '../interfaces';

export function getDriverTimezone(company: CompanyPayload, driver?: DriverPayload) {
  const driverHomeTerminalId = driver?.driverInfo?.homeTerminal?.id;
  return driverHomeTerminalId
    ? company.terminals.find((terminal) => terminal.id === driverHomeTerminalId)?.timeZone?.id ?? company.timeZone.id
    : company.timeZone.id;
}
